import styled from 'styled-components';

import {getColor, getRem, square} from '../../styles';
import {ms} from '../../styles/normalizeSize';
import {Button} from '../../uikit/Button';
import {Text} from '../../uikit/Text';
import {View} from '../../uikit/View';

export const Container = styled(View)`
  position: relative;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: center;
  padding: ${ms(25)};
`;

export const Icon = styled(({color, component, iconSize, ...rest}) => {
  const Component = component;

  return <Component {...rest} />;
}).attrs(p => ({
  fill: getColor(p.color)(p),
}))`
  margin-block-end: ${ms(10)};
  ${p => square(p.iconSize)};
`;

const SText = styled(Text)`
  width: ${ms(230)};
  font-size: ${getRem(15)};
  line-height: ${getRem(20)};
  text-align: center;
`;

export {SText as Text};

export const Description = styled(Text)`
  width: ${ms(250)};
  font-size: ${getRem(13)};
  line-height: ${getRem(28)};
  text-align: center;
  padding-block-start: ${ms(10)};
`;

const SButton = styled(Button)`
  max-width: ${ms(230)};
  margin-top: ${ms(15)};
`;

export {SButton as Button};

export const ButtonText = styled(Text).attrs({weight: 'semibold'})`
  font-size: ${getRem(13)};
  color: ${getColor('text.white')};
`;
